import axios from "axios";
import { AccessToken } from "../utils";

const get = (
  url,
  params = {},
  dropdown_format = false,
  signal = null,
  rawRes = false,
  extraConfig = null
) => {
  if (AccessToken() === null) {
    window.location.href = "/login";
  }
  return axios
    .get(url, {
      headers: { "Content-Type": "application/json", ...(extraConfig?.headers || {}) },
      params: params,
      withCredentials: true,
      ...(signal && { signal }),
      ...(extraConfig || {}),
    })
    .then((res) => {
      if (dropdown_format && url.endsWith("/accounts/")) {
        return res.data.map((o) => ({
          value: o.id,
          label: o.number + " - " + o.name,
        }));
      } else if (dropdown_format) {
        const items = res.data.results || res.data;
        return items.map((o) => ({ value: o.id, label: o.name }));
      } else if (rawRes) {
        return res;
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      // Silently swallow AbortError when the caller cancelled the request
      if (signal && err?.name === "CanceledError") return;
      throw err;
    });
};

const patch = (url, data, contentTypeOrConfig = "application/json") => {
  const baseConfig = { withCredentials: true };
  const isFormData = data instanceof FormData;

  if (typeof contentTypeOrConfig === "string") {
    const headers = isFormData ? {} : { "Content-Type": contentTypeOrConfig };
    return axios.patch(url, data, {
      ...baseConfig,
      headers,
    });
  }

  const config = contentTypeOrConfig || {};
  const headers = { ...(config.headers || {}) };
  if (!isFormData) {
    headers["Content-Type"] = config?.headers?.["Content-Type"] ?? "application/json";
  }

  return axios.patch(url, data, {
    ...baseConfig,
    ...config,
    headers,
  });
};

const post = (url, data, contentTypeOrConfig = "application/json") => {
  const baseConfig = { withCredentials: true };
  const isFormData = data instanceof FormData;

  if (typeof contentTypeOrConfig === "string") {
    const headers = isFormData ? {} : { "Content-Type": contentTypeOrConfig };
    return axios.post(url, data, {
      ...baseConfig,
      headers,
    });
  }

  const config = contentTypeOrConfig || {};
  const headers = { ...(config.headers || {}) };
  if (!isFormData) {
    headers["Content-Type"] = config?.headers?.["Content-Type"] ?? "application/json";
  }

  return axios.post(url, data, {
    ...baseConfig,
    ...config,
    headers,
  });
};

const deleteRequest = (url) => {
  return axios.delete(url);
};

export { get, patch, post, deleteRequest };
